import { GQL } from "@binale-tech/shared";

import { AppRoutes, getRoute, ModuleSubGroups } from "@domain/routing/routeConstants";

/** The page that lists the records of a product; undefined for a product without one. */
export const productRoute = (product: GQL.IProductKey): string | undefined => {
    switch (product) {
        case GQL.IProductKey.Er:
            return getRoute(AppRoutes.invoiceModule, { subGroup: ModuleSubGroups.ER });
        case GQL.IProductKey.ErA:
            return getRoute(AppRoutes.invoiceModule, { subGroup: ModuleSubGroups.ErA });
        case GQL.IProductKey.Deb:
            return AppRoutes.debitor;
        case GQL.IProductKey.Kb:
            return AppRoutes.kassenbuch;
        case GQL.IProductKey.Bank:
            return AppRoutes.bank;
        case GQL.IProductKey.Fe:
            return AppRoutes.freieErfassung;
        case GQL.IProductKey.La:
            return AppRoutes.paySlip;
        case GQL.IProductKey.Pos:
            return AppRoutes.pos;
        default:
            return undefined;
    }
};
